import React, { useRef } from 'react';
import classnames from 'classnames';
import GlobalProps from '../../globalProps';
import './FileUpload.css';
import { Icon } from '../../Icon/Icon';
import { IconName } from '../../Icon/IconName';
import './../input.scss';
import { t } from '../../../locales/translate';
import { imageUrl } from '../../../model/asset';
import { Collapse } from '@nerdgeschoss/shimmer-component-collapse';

interface Props extends GlobalProps {
  image?: string | null;
  alt?: string;
  label?: string;
  error?: boolean;
  description?: string;
  icon?: IconName;
  onChange?: (e: File[]) => void;
  multiple?: boolean;
  required?: boolean;
}

export function FileUpload({
  image,
  alt,
  label,
  error,
  multiple,
  onChange,
  className,
  description,
  style,
  icon,
  required,
}: Props): JSX.Element {
  const fileUpload: React.MutableRefObject<HTMLInputElement | null> = useRef(null);

  function handleOnChange(fileList: FileList): void {
    if (onChange && fileList) {
      onChange(Array.from(fileList));
      if (fileUpload.current) {
        fileUpload.current.value = '';
      }
    }
  }

  return (
    <div className={classnames('file-upload', 'input', { 'input--with-icon': icon }, className)} style={style}>
      {icon && <Icon name={icon} className="input__icon" />}
      <div className="input__container input__container--full">
        <div className="input__input-wrapper">
          {label && (
            <label className="input__label">
              {label}
              {!required && ` (${t.general.optional})`}
            </label>
          )}
          {image && (
            <div className="file-upload__wrapper">
              <img className="file-upload__image" src={imageUrl(image)} alt={alt} />
              <div className="file-upload__remove-button" onClick={() => onChange && onChange([])}>
                <Icon name="remove-circle--sm" />
              </div>
            </div>
          )}
          {!image && (
            <div className="file-upload__input">
              <input
                type="file"
                ref={fileUpload}
                className="input__input"
                accept="image/*"
                onChange={(e) => {
                  if (e.target.files) {
                    handleOnChange(e.target.files);
                  }
                }}
                required={required}
                multiple={multiple}
              />
            </div>
          )}
        </div>
        <div className="input__description-wrapper">
          {description && <div className="input__description">{description}</div>}
          <Collapse open={error ? true : false}>
            <div className="input__error-message">{error}</div>
          </Collapse>
        </div>
      </div>
    </div>
  );
}
